<template>
  <div class="date-picker-wrapper">
    <button class="btn btn-light mr-1" @click="navigateDate(-1)">&lt;&lt;</button>

    <div class="input-group">
      <flatPickr class="form-control" v-model="localDate" :config="config" />
      <div class="input-group-append">
        <span class="input-group-text"><i class="fas fa-calendar-day fa-lg"></i></span>
      </div>
    </div>

    <button class="btn btn-light ml-1" @click="navigateDate(1)">>></button>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'DatePicker',
  components: {
    flatPickr
  },
  props: {
    modelValue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      localDate: this.modelValue,
      config: {
        dateFormat: 'Y-m-d',
        defaultDate: this.modelValue
      }
    };
  },
  watch: {
    modelValue(newVal) {
      this.localDate = newVal;
    },
    localDate(newDate) {
      this.$emit('update:modelValue', newDate);
    },
  },
  methods: {
    navigateDate(direction) {
      const date = new Date(this.localDate);
      date.setDate(date.getDate() + direction);
      this.localDate = date.toISOString().split('T')[0];
    },
  }
};
</script>

<style lang="scss" scoped>
.date-picker-wrapper {
  display: flex;
  align-items: center;

  button {
    border: none;
  }

  input {
    border: none;
    background-color: #3b4651;
  }

  .input-group-text {
    padding: 10px 20px;
  }
}
</style>